"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { IconGlyphicon } from 'generics/icons';
import { _I_, defineSimpleTerm } from 'components/locs';


function filterFn( terms, item )  {
  if ( terms.length == 0 )
    return true;

  const info = item.classInfo;
  if ( !info )
    return true;

  const descriptions = (info.descriptions||[]).map( (d) => ((d||{}).value) );

  const combinedText = [
      info.name,  info.market_name,
      ...descriptions
    ].filter( Boolean ).join( " " ).toLowerCase();

  let allowed = terms.every( (term) => (combinedText.indexOf(term) >= 0) );
  return allowed;
}


function NoopFilterFunc( item )  {
  return true;
}


export class ViewInventoryTextFilter extends React.Component  {
  constructor(props)  {
    super(props);
  }


  onTextFilterChange()  {
    if ( this.searchInput )  {
      const terms = this.searchInput.value.split(" ").map(
                        (term) => term.trim().toLowerCase()
                      ).filter( Boolean );

      if ( terms.length )  {
        const boundFilterFunc = ( item ) => filterFn( terms, item );
        this.props.onChangeFilter( boundFilterFunc );
        return;
       }
    }

    this.props.onChangeFilter( NoopFilterFunc );
  }


  onTextFilterClear()  {
    this.props.onChangeFilter( NoopFilterFunc );
    if ( this.searchInput )
      this.searchInput.value = "";
  }


  render()  {
    const classes = ["inventory-filters", (this.props.hidden && "hidden" || "")].join(" ");
    return (
        <div className={classes}>
          <div className="search-label">
            {_I_("ViewInventoryTextFilter.common.label")}
          </div>

          <div className="input-holder">
            <input
                  type="text"
                  className="form-control input-sm"
                  placeholder={_I_("ViewInventoryTextFilter.common.placeholder")}
                  ref={ (searchInput) => {this.searchInput = searchInput;} }
                  onKeyUp={ () => this.onTextFilterChange() }
                />

            <div  className="filter-reset"
                  onClick={ () =>  this.onTextFilterClear()}
                >
              <IconGlyphicon type="remove-circle" />
            </div>

          </div>
        </div>
      );
  }


}


defineSimpleTerm( "ViewInventoryTextFilter.common.placeholder",  "Start typing here to filter items",       {
    "ru_RU": "Введите сюда текст для фильтрации",
    "cs_CZ": "Začněte psát sem pro filtrování předmětů",
    "fr_FR": "Ecrivez ici pour filtrer les items",
    "de_DE": "Hier ausfüllen um Items zu filtern",
    "it_IT": "Start typing here to filter items",
    "ko_KR": "Start typing here to filter items",
    "pl_PL": "Wpisz szukaną frazę",
    "pt_PT": "Escrever aqui para filtrar itens",
    "es_ES": "Comienza a escribir aquí para filtrar elementos",
    "zh_CN": "在此处输入以筛选物品",
    "zh_TW": "在此處輸入以篩選物品"
} );


defineSimpleTerm( "ViewInventoryTextFilter.common.label",  "Looking for a specific item?",       {
    "ru_RU": "Ищете что-то конкретное?",
    "cs_CZ": "Hledáte něco konkrétního?",
    "fr_FR": "Vous recherchez un item spécifique?",
    "de_DE": "Suchst du ein bestimmtes Item?",
    "it_IT": "In cerca di un oggetto specifico?",
    "ko_KR": "찾고자 하는 아이템이 무엇입니까?",
    "pl_PL": "Szukasz konkretnego przedmiotu?",
    "pt_PT": "Looking for a specific item?",
    "es_ES": "¿Buscando un artículo específico?",
    "zh_CN": "是否在查找特定物品？",
    "zh_TW": "是否在查找特定物品？"
} );

